import { AMC_MANDATORY_DOCUMENTS } from '../../actions/allSureMotorClaim/types';
import {
    AMC_UPLOAD_DOCUMENTS_RESET,
    AMC_UPLOAD_DOCUMENTS_SET_VALID,
    AMC_UPLOAD_DOCUMENTS_SET_VALUE,
    AMC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE,
    AMC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT,
    AMC_SYNC_DOCUMENTS,
} from '../../actions/allSureMotorClaim/uploadDocuments';

import { FIELD_STATUS, FORM_STATUS } from '../status';

const defaultValue = { fileName: null, fileContaint: null, error: null, status: FIELD_STATUS.VALID, file: null };

export const initUploadDocument = {
    formStatus: FORM_STATUS.INVALID,
    category: null,
    form: {
        certifiedCopyOfId: defaultValue,
        policeReport: defaultValue,
        repairQuotes: defaultValue,
    },
};

export default (state = initUploadDocument, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    switch (action.type) {
        case AMC_UPLOAD_DOCUMENTS_SET_VALUE:
            const { inputType, fileName, fileContaint, file } = action.value;
            return updateFormField(inputType, (field) => ({
                ...field,
                fileName: fileName,
                fileContaint: fileContaint,
                file: file,
            }));

        case AMC_UPLOAD_DOCUMENTS_SET_VALID:
            return updateFormField(action.fileType, (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case AMC_SYNC_DOCUMENTS:
            return {
                ...state,
                category: action.value,
                form: Object.fromEntries(AMC_MANDATORY_DOCUMENTS[action.value].map((key) => [key, defaultValue])),
            };
            
        case AMC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT:
            return {
                ...state,
                form: {
                    ...state.form,
                    [`additionalDocument_${Object.keys(state.form).length}`]: {
                        fileName: null,
                        fileContaint: null,
                        error: null,
                        status: null,
                        file: null,
                        dependentValue: null,
                        dependentField: `additionalDocument_${Object.keys(state.form).length}`,
                        validationCondition: (currentfield, dependentField) => !!dependentField.fileName,
                    },
                },
            };

        case AMC_UPLOAD_DOCUMENTS_RESET:
            return { ...state, form: initUploadDocument.form };

        case AMC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE:
            const existingForm = {
                ...state.form,
            };
            action?.value?.forEach((item) => {
                const documentNameKey = item.documentName;
                if (existingForm[documentNameKey]) {
                    existingForm[documentNameKey].url = item.url;
                }
            });
            return { ...state, form: existingForm };

        default:
            return state;
    }
};
